import { useTheme } from 'styled-components';
import { useDarkTheme } from './useDarkTheme';
import { useLightTheme } from './useLightTheme';
export const useInvertedTheme = () => {
    const surroundingTheme = useTheme();
    const darkTheme = useDarkTheme();
    const lightTheme = useLightTheme();
    if (surroundingTheme.name === darkTheme.name) {
        return lightTheme;
    }
    else {
        return darkTheme;
    }
};
//# sourceMappingURL=useInvertedTheme.js.map